// crewbit-admin/src/components/schedule/RouteToggleButton.tsx
//
// Schedule Module Phase C C4 — "Show route" / "Hide route" toggle on admin
// Day view. Per spec §5.3.

import { Map, EyeOff } from 'lucide-react';
import { palette, admin } from '../../styles/tokens';

export interface RouteToggleButtonProps {
  active: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export function RouteToggleButton({ active, onToggle, disabled }: RouteToggleButtonProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      aria-pressed={active}
      style={{
        display: 'flex', alignItems: 'center', gap: 6,
        padding: '6px 12px',
        borderRadius: 8,
        background: active ? palette.accentWash : 'transparent',
        border: `1px solid ${active ? palette.accent : admin.border}`,
        color: active ? palette.accent : admin.body,
        fontSize: 13, fontWeight: 600,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {active ? <EyeOff size={14} /> : <Map size={14} />}
      {active ? 'Hide route' : 'Show route'}
    </button>
  );
}
